import type { KambiSportsSelection } from '@mobi/betslip/types'
import type { QuickbetSelection } from '@core/Areas/Quickbet/types'
import type { KambiSportBetDetails } from '@core/Areas/ShareBet/LoadBet/types'
import { getKambiBetOffersByIds } from '@core/Areas/Kambi/helpers/api/offering'

export const buildKambiSportsBet = async ({
  betSelectionType,
  betOfferIds,
  outcomeIds,
}: KambiSportBetDetails): Promise<QuickbetSelection> => {
  const { betOffers, events } = await getKambiBetOffersByIds({ betOfferIds })

  if (betOffers.length === 0) throw new Error('Unable to build sport bet')

  const selection: KambiSportsSelection = {
    betSelectionType,
    betOffers: betOffers.map(offer => {
      const outcomes = offer.outcomes.filter(outcome => outcomeIds.includes(outcome.id))
      return { ...offer, outcomes }
    }),
    outcomeIds,
    events,
  }

  return {
    bettingType: 'kambi-sports',
    selection,
    selectionDetails: null,
    isEachWayAvailable: false,
    shouldAllowPlaceInvestment: false,
  }
}
